import { render } from "./PasswordForgot.vue?vue&type=template&id=5a548da8"
import script from "./PasswordForgot.vue?vue&type=script&lang=js"
export * from "./PasswordForgot.vue?vue&type=script&lang=js"

import "./PasswordForgot.vue?vue&type=style&index=0&id=5a548da8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__